import { render, staticRenderFns } from "./GrmSlider.vue?vue&type=template&id=0da0b48e&scoped=true&"
import script from "./GrmSlider.vue?vue&type=script&lang=js&"
export * from "./GrmSlider.vue?vue&type=script&lang=js&"
import style0 from "./GrmSlider.vue?vue&type=style&index=0&id=0da0b48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0b48e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da0b48e')) {
      api.createRecord('0da0b48e', component.options)
    } else {
      api.reload('0da0b48e', component.options)
    }
    module.hot.accept("./GrmSlider.vue?vue&type=template&id=0da0b48e&scoped=true&", function () {
      api.rerender('0da0b48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/slider/GrmSlider.vue"
export default component.exports